export const pageTitle = 'COS PE';

export const REGEX = new RegExp('^[0-9,]*$|^$'); // Regex to validate only number input values
